import {
  ADD_DETAILS,
  CHOOSE,
  HOW,
  LARGE,
  NARROW,
  ADD_RETURN_REASONS,
} from "../core-modules/constants";
import React, { useEffect } from "react";

import OnlineAddDetails from "./OnlineAddDetails";
import Box from "./Box";
import Choose from "./Choose";
import How from "./How";
import Progress from "./Progress";
import PropTypes from "prop-types";
import TakebackLayout from "./TakebackLayout";
import { useAppContext } from "./AppContext";
import { useBrand } from "./BrandContext";
import HoldingPageContent from "./HoldingPageContent";
import AddReturnReasons from "./AddReturnReasons";
import { theme } from "../core-modules/theme";
import { useRouter } from "next/router";
import { getBrandFonts } from "../core-modules/utils";
import { useTakebackConfig } from "./TakebackConfigContext";

function OnlineTakeback({ embedMode }) {
  const { currentStep, setCurrentStep } = useAppContext();
  const router = useRouter();
  const { slug } = router.query;
  const { hasBrandFont, live, holdingPageContent } = useBrand();
  const { headerTextMain, headerTextSub, addDetailsHeading } =
    useTakebackConfig();

  useEffect(() => {
    if (hasBrandFont) {
      const brandFonts = getBrandFonts(slug);
      if (brandFonts) {
        theme.fonts.main = brandFonts.main;
        theme.fonts.bold = brandFonts.bold;
      }
    }
  }, []);

  const headings = {
    how: {
      mainHeading: headerTextMain,
      subheading: headerTextSub,
    },
    choose: {
      mainHeading: "Let's put your pre-loved items to good use.",
      subheading: "",
    },
    addReturnReasons: {
      mainHeading: "Why are you recycling these items?",
      subheading: "",
    },
    addDetails: {
      mainHeading: addDetailsHeading || "Complete your takeback",
      subheading: "",
    },
  };
  let stepComponent;

  if (!live) {
    stepComponent = <HoldingPageContent content={holdingPageContent} />;
  } else {
    if (currentStep === HOW)
      stepComponent = <How setCurrentStep={setCurrentStep} />;
    if (currentStep === CHOOSE)
      stepComponent = <Choose embedMode={embedMode} />;
    if (currentStep === ADD_RETURN_REASONS)
      stepComponent = <AddReturnReasons />;
    if (currentStep === ADD_DETAILS)
      stepComponent = <OnlineAddDetails setCurrentStep={setCurrentStep} />;
  }

  return (
    <TakebackLayout
      embedMode={embedMode}
      headings={headings[currentStep]}
      size={currentStep === HOW ? LARGE : NARROW}
      title="Reskinned | Takeback"
    >
      {live && <Progress />}
      <Box pt={[50, null, 80, null]}>{stepComponent}</Box>
    </TakebackLayout>
  );
}

OnlineTakeback.propTypes = {
  embedMode: PropTypes.bool.isRequired,
};

export default OnlineTakeback;
